module.exports = __webpack_public_path__ + "img/fr.e35c2954.svg";